// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3MbTl","bigColWidth":"Table_bigColWidth__1EL4F","biggerColWidth":"Table_biggerColWidth__2MXvd","row":"Table_row__2ip1l","col":"Table_col__gxwX5"};